import { Inject, Injectable } from '@angular/core'
import { SETTING, SettingsRegistry } from '@features/settings/settings-registry'
import { SupportedScripts } from '@features/script-loader'
import { CookieStorageService } from '@features/cookie-consents/cookie-storage.service'
import { COOKIE_CONSENT_LEVEL } from '@features/cookie-consents/contracts'
import { EMPTY, switchMap, take, tap } from 'rxjs'
import { Script, ScriptLoader } from '@sun-finance/utils'
import { WINDOW } from '@features/storage/window'

export type Configuration = {
  tag: string
  color: string
  logo: string
}

@Injectable({
  providedIn: 'root',
})
export class ZendeskInitializerService {

  constructor(private settings: SettingsRegistry, private scriptLoader: ScriptLoader, private cookie: CookieStorageService, @Inject(WINDOW) private window: Window) {
  }

  initialize(config: Configuration): Script {
    if (!this.settings.get(SETTING.USE_CHAT, false)) {
      return EMPTY
    }

    const loadScript = () => this.scriptLoader.load(SupportedScripts.ZENDESK, { dataAttrs: { key: this.settings.get(SETTING.ZENDESK_KEY, '') } })
    return this.cookie
      .onConsent(COOKIE_CONSENT_LEVEL.FUNCTIONALITY)
      .pipe(
        switchMap(loadScript),
        take(1),
        tap(() => {
          if(this.window.$zopim) {
            this.window.$zopim(() => {
              const chat = this.window.$zopim! // Config is available only after ready callback
              const path = this.window.document.getElementsByTagName('base')[0].href

              chat.livechat.theme.setColors({ badge: config.color, primary: config.color })
              chat.livechat.concierge.setAvatar(`${path}assets/${config.logo}`)
              chat.livechat.addTags(config.tag)
            })
          }
        }),
      )
  }
}
